import React from "react";

class Order {
    static register = {
        ORDER_HISTORY: {slug: 'ORDER_HISTORY', render: <></>},
    };
}

export default Order;